import { Price } from "@/types/price";
import loadStripeWithRetry from "@/utils/loadStripeWithRetry";
import { Elements } from "@stripe/react-stripe-js";
import { FunctionComponent } from "react";
import { CheckoutForm } from "./CheckoutForm";
import { BetweenPricingAndPaymentProps, PaymentFormData } from "./types";

export function PaymentFormControl({
    HeaderComponent,
    BetweenPricingAndPaymentComponent,
    paymentFormData,
    selectedPrice,
    onPaymentComplete,
}: {
    HeaderComponent?: FunctionComponent<{
        paymentFormData: PaymentFormData;
    }>;
    BetweenPricingAndPaymentComponent?: FunctionComponent<BetweenPricingAndPaymentProps>;
    paymentFormData: PaymentFormData;
    selectedPrice: Price;
    onPaymentComplete?: () => void;
}) {
    const stripePromise = loadStripeWithRetry();

    return (
        <div
            data-testid="payment-checkout-container"
            // If the mt-8 below gets changed, also change the -my-8 override in PayUsModalsProvider.tsx
            className="w-full mt-8 flex flex-col bg-brand-white drop-shadow-top sm:mb-8 sm:max-w-xl sm:rounded sm:shadow-lg"
        >
            {HeaderComponent && paymentFormData && (
                <HeaderComponent paymentFormData={paymentFormData} />
            )}
            <Elements
                stripe={stripePromise}
                options={{
                    clientSecret:
                        paymentFormData.setupIntent.client_secret ?? "",
                }}
            >
                <CheckoutForm
                    paymentFormData={paymentFormData}
                    selectedPrice={selectedPrice}
                    onPaymentComplete={onPaymentComplete}
                    BetweenPricingAndPaymentComponent={
                        BetweenPricingAndPaymentComponent
                    }
                />
            </Elements>
        </div>
    );
}
